import { Link, makeStyles } from "@material-ui/core";
import * as React from "react";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles({
  link: {
    "& > span": {
      lineHeight: 1
    },
    "& > a": {
      textDecoration: "none"
    },
    display: "inline-block" as "inline-block",
    lineHeight: "1.8rem",
    overflowWrap: "anywhere" as "anywhere",
    verticalAlign: "middle" as "middle"
  }
});

interface IOwnProps {
  to: string | { pathname: string; state?: object };
  children: React.ReactNode;
  dataTestId?: string;
}
const CustomLink = ({ to, children, dataTestId }: IOwnProps) => {
  const classes = useStyles();
  const Navigate = React.forwardRef((props: any, ref: any) => (
    <RouterLink data-qa-selector={dataTestId} to={to} {...props} ref={ref} />
  ));

  return (
    <Link className={classes.link} color="primary" variant="subtitle2" component={Navigate}>
      <span>{children}</span>
    </Link>
  );
};

export default React.memo(CustomLink);
